// Параметры текущего сезона по ответам клиента от 23.10.2026 (NO-384, NO-387).

// Год приёма заявок (YEAR на бэкенде)
export const FESTIVAL_YEAR = 2027

// Год победителей, которые сдают отчёты (REPORTS_YEAR на бэкенде)
export const REPORTS_YEAR = 2026

// Дедлайн приёма заявок для страницы входа, например "до 1 февраля 2027".
// Пусто — подзаголовок не показывается (клиент просил скрыть «Успейте подать заявку до …»).
export const APPLICATION_DEADLINE_TEXT = ""

// Границы сроков реализации проекта в анкете нового сезона по ответу клиента (NO-390).
// Бэкенд (artists/forms.py) должен проверять те же границы: PROJECT_START_DATE / PROJECT_END_DATE в .env.
export const PROJECT_START_MIN = "20.03.2027"
export const PROJECT_END_MAX = "19.07.2027"

// Хештег фестиваля для задания про анонс в соцсетях
export const FESTIVAL_HASHTAG = `#NewOpen${FESTIVAL_YEAR}`

// Границы сроков реализации проекта в отчёте победителей прошлого сезона
export const REPORT_PROJECT_START_MIN = `10.11.${REPORTS_YEAR}`
export const REPORT_PROJECT_END_MAX = `10.03.${REPORTS_YEAR + 1}`

// Подписи этапов отчёта победителя. Периоды этапов ждём от клиента.
export const REPORT_STAGE_NAMES: { [key in string]: string } = {
  stage1: "Этап 1 (промежуточный)",
  stage2: "Этап 2 (итоговый)"
}
